import { useEffect, useState } from "react";
import { formatTimeRemainingUntil } from "../utils/studentRecentContent";

/** Tick clock for live “starts in …” labels. */
export function useCountdownNow(enabled = true, intervalMs = 30_000) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!enabled) return undefined;
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [enabled, intervalMs]);

  return now;
}

export function useStartsInLabel(startTime, intervalMs = 30_000) {
  const enabled = Boolean(startTime);
  const now = useCountdownNow(enabled, intervalMs);
  return formatTimeRemainingUntil(startTime, now);
}
